import { Grid, Paper } from '@mui/material';
import { useState, useMemo, useEffect } from 'react';
import SearchField from 'src/shared/components/form/searchField';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import { PageFilterSection } from 'src/shared/components/organisms/pageFilterSection';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { useLocalStorage } from 'src/shared/hooks/useLocalStorage';
import { LocalStorageKeys } from 'src/shared/models/enums/localStorageKeys.enum';
import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from 'src/shared/models/enums/gridFilterConfig';
import { FundraiserSettingsDataGrid } from '../components/fundraiserSettingsDataGrid';
import { FundraiserSettingsSearchFilter } from '../models/fundraiserSettingsSearchFilter';

export const FundraiserSettingsOverviewPage = () => {
  const isMounted = useIsMounted();

  const [tempSearchString, setTempSearchString] = useState<string | undefined>(undefined);
  const [searchInitialized, setSearchInitialized] = useState<boolean>(false);
  const [fundraiserSearchFilter, setFundraiserSearchFilter] = useLocalStorage(LocalStorageKeys.FundraiserSettingsSearchFilter, {
    sortCol: 'fundraiser_id',
    sortDir: 'desc',
    pageIndex: DEFAULT_PAGE_INDEX,
    pageSize: DEFAULT_PAGE_SIZE,
  } as FundraiserSettingsSearchFilter);

  const searchFilter: FundraiserSettingsSearchFilter = useMemo(() => {
    return {
      filter: fundraiserSearchFilter?.filter,
      pageSize: fundraiserSearchFilter?.pageSize,
      pageIndex: fundraiserSearchFilter?.pageIndex,
      sortCol: fundraiserSearchFilter?.sortCol,
      sortDir: fundraiserSearchFilter?.sortDir,
    } as FundraiserSettingsSearchFilter;
  }, [
    fundraiserSearchFilter?.filter,
    fundraiserSearchFilter?.pageIndex,
    fundraiserSearchFilter?.pageSize,
    fundraiserSearchFilter?.sortCol,
    fundraiserSearchFilter?.sortDir,
  ]);

  useEffect(() => {
    if (isMounted() && searchInitialized) {
      if (tempSearchString === '') {
        setFundraiserSearchFilter((prev) => ({ ...prev, ...{ filter: '', pageIndex: 0 } }));
      }
      if (tempSearchString && tempSearchString.length >= 2) {
        setFundraiserSearchFilter((prev) => ({ ...prev, ...{ filter: tempSearchString, pageIndex: 0 } }));
      } else {
        setFundraiserSearchFilter((prev) => ({ ...prev, ...{ filter: '', pageIndex: 0 } }));
      }
    }
  }, [isMounted, searchInitialized, setFundraiserSearchFilter, tempSearchString]);

  return (
    <GridWrapper>
      <Grid item xs={12}>
        <Paper>
          <PageFilterSection
            leftContent={
              <SearchField
                initialValue={searchFilter.filter || ''}
                onSearch={(newSearchString) => {
                  setSearchInitialized(true);
                  setTempSearchString(newSearchString);
                }}
              />
            }
          />
          <FundraiserSettingsDataGrid
            loadingCallback={(x) => ConsoleHelper.log(x)}
            searchFilter={searchFilter}
            searchFilterCallback={(newFilter) =>
              setFundraiserSearchFilter((prev) => ({
                ...prev,
                ...newFilter,
              }))
            }
          />
        </Paper>
      </Grid>
    </GridWrapper>
  );
};
